import React, { useEffect, useState } from "react";
import { ROLES } from "../../constants";
import { getCurrentUser } from "../../controllers/dashboardController";
import ManagerDashboard from "./ManagerDashboard";
import UserDashboard from "./UserDashboard";

// `/employee/dashboard` is shared by the "user" and "manager" roles; each gets
// its own dashboard.
const EmployeeDashboard = () => {
  const [me, setMe] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    getCurrentUser()
      .then((user) => !cancelled && setMe(user))
      .catch(() => !cancelled && setError(true));
    return () => {
      cancelled = true;
    };
  }, []);

  if (error) {
    return <div className="flex justify-center py-20 text-app-error">Failed to load your dashboard.</div>;
  }
  if (!me) {
    return <div className="flex justify-center py-20 text-app-muted">Loading dashboard…</div>;
  }
  return me.role === ROLES.MANAGER ? <ManagerDashboard /> : <UserDashboard me={me} />;
};

export default EmployeeDashboard;
